const url = {
    DUBAI_MAP: "https://www.google.com/maps/search/Meydan%20Grandstand,%206th%20floor,%20Meydan%20Road,%20Nad%20AI%20Sheba,%20Dubai,%20U.A.E.%20Dubai%20United%20Arab%20Emirates%209305",
    TEL: "tel:0850 303 46 38",
    MAIL: "mailto:info@tein.com.tr",
    INSTA: "https://www.instagram.com/stratixbusiness",
    TIKTOK: "https://www.tiktok.com/@stratixbusiness.t?_r=1&_t=ZS-92rnurr3Auu",
    LINKD: "https://www.linkedin.com/company/stratixbusiness-technology-l-l-c-fz/",

}

export default url